/*
 * @Author: tony.zhu
 * @Date: 2023-12-01 11:11:06
 * @LastEditTime: 2025-09-11 17:46:36
 * @LastEditors: tony.zhu
 * @Description: 
 */

export const commonMixinByTooltip = {
    data() {
        return {
            isShowTooltip: false
        }
    },
    methods: {
        /**
         * @ 鼠标经过 （主要用于文字提示）
         */
        onIsShowTooltipByMouseOver(str, line = 1) {
            if (document.querySelector(`#${str}`)) {
                if (line > 1) {
                    const style = window.getComputedStyle(document.querySelector(`#${str}`))
                    let scrollHeight = document.querySelector(`#${str}`).scrollHeight;
                    if (scrollHeight <= parseFloat(style.lineHeight) * line) {
                        this.isShowTooltip = true;
                    } else {
                        this.isShowTooltip = false;
                    }
                } else {
                    let parentWidth = document.querySelector(`#${str}`).parentNode
                        .getBoundingClientRect().width;
                    let contentWidth = document.querySelector(`#${str}`).getBoundingClientRect().width;
                    // 判断是否开启tooltip功能
                    if (contentWidth * line > parentWidth) {
                        this.isShowTooltip = false;
                    } else {
                        this.isShowTooltip = true;
                    }
                }

            }
        }
    }
}

import tool, {
    addEventListener,
    debounce,
} from "@/components/aiChat/utils/tbox.js";


// 根据键盘获取方向
export const onGetDirectionByKeyCode = (e) => {
    let direction = ''
    switch (e.keyCode) {
        case 37: // 左箭头
            direction = 'left'
            break;
        case 39: // 右箭头
            direction = 'right'
            break;
        case 27: // esc
            direction = 'esc'
            break;
        case 46: // del
            direction = 'del'
            break;
    }
    return direction
}

export const commonMixin = {
    data() {
        return {
            windowResizeInstance: null,
            keyupInstance: null
        }
    },
    methods: {
        // 获取 node 节点信息
        onGetContentBoundingClient(Class, categoryCur = 0) {
            return new Promise((resolve, reject) => {
                try {
                    const el = document.querySelectorAll(Class);
                    const rect = tool.getObjXy(el[categoryCur]);
                    resolve(rect);
                } catch (e) {
                    reject(e);
                }
            });
        },
        // 监听窗口resize
        onHandWatchWindowResize(cb, waitTime = 200) {
            // TODO 执行一次
            if (this.windowResizeInstance) {
                this.windowResizeInstance.remove(window, "resize", () => {
                    cb()
                });
                this.windowResizeInstance = null;
            }
            // 监听窗口变化
            this.windowResizeInstance = addEventListener.listen(window, "resize", debounce(function () {
                cb();
            }, waitTime));
        },

        // 监听 键盘事件
        onWatchKeyup(cb) {
            // TODO 确认在document只绑定一次 once
            if (this.keyupInstance) {
                this.keyupInstance.remove(document, 'keyup', onGetDirectionByKeyCode)
                this.keyupInstance = null
            }
            this.keyupInstance = addEventListener.listen(document, "keyup", (e) => {
                cb(onGetDirectionByKeyCode(e))
            })
        },

        // 匀速滚动回顶部
        backTop(node = document.body) {
            if (!node) {
                return
            }
            let timer = setInterval(() => {
                let ispeed = Math.floor(-node.scrollTop / 5)
                node.scrollTop = node.scrollTop + ispeed
                if (node.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
    },
    beforeDestroy() {
        if (this.windowResizeInstance) {
            this.windowResizeInstance.remove(window, "resize", () => {});
            this.windowResizeInstance = null;
        }
    }
}